import { useAuthStore } from '@/stores/auth.store';

export type RoutePermissionInput = string | string[];
export type RoutePermissionMode = 'all' | 'any';

export function resolveRoutePermission(
  grantedPermissions: readonly string[],
  requiredPermissions: RoutePermissionInput,
  mode: RoutePermissionMode = 'all',
) {
  const required = Array.isArray(requiredPermissions) ? requiredPermissions : [requiredPermissions];
  const normalizedRequired = required.filter(Boolean);

  if (normalizedRequired.length === 0) return true;

  return mode === 'any'
    ? normalizedRequired.some((permission) => grantedPermissions.includes(permission))
    : normalizedRequired.every((permission) => grantedPermissions.includes(permission));
}

export function useRoutePermission(
  requiredPermissions: RoutePermissionInput,
  mode: RoutePermissionMode = 'all',
) {
  return useAuthStore((state) =>
    resolveRoutePermission(state.permissions, requiredPermissions, mode),
  );
}
